/**
 * Ícones das mensagens automáticas e dos anexos.
 *
 * O corpo das mensagens de sistema (e o preview das conversas) chega com um
 * emoji-prefixo. Aqui traduzimos para ícones Lucide — a UI nunca mostra emoji.
 */
import {
  Archive,
  CheckCheck,
  CheckCircle2,
  File,
  Flag,
  Image,
  Info,
  LogOut,
  MapPin,
  Mic,
  Palette,
  Paperclip,
  Pencil,
  PlayCircle,
  RefreshCcw,
  RotateCw,
  UserMinus,
  UserPlus,
  Video,
  XCircle,
} from "lucide-react";

export const SYSTEM_ICONS = {
  "🤝": CheckCheck,
  "▶": PlayCircle,
  "🔄": RotateCw,
  "📍": MapPin,
  "🏁": Flag,
  "✅": CheckCircle2,
  "❌": XCircle,
  "↻": RefreshCcw,
  "📷": Image,
  "🎥": Video,
  "🎙️": Mic,
  "🎙": Mic,
  "📎": Paperclip,
  "📄": File,
  // Gestão de grupo (chat Web)
  "✏️": Pencil,
  "✏": Pencil,
  "🎨": Palette,
  "➖": UserMinus,
  "➕": UserPlus,
  "🚪": LogOut,
  "📦": Archive,
};

/** Separa o emoji-prefixo do texto e devolve o ícone equivalente. */
export function parseSystemMessage(body) {
  const trimmed = (body || "").trimStart();
  for (const emoji of Object.keys(SYSTEM_ICONS)) {
    if (trimmed.startsWith(emoji)) {
      return {
        Icon: SYSTEM_ICONS[emoji],
        text: trimmed.slice(emoji.length).trimStart(),
        hasIcon: true,
      };
    }
  }
  return { Icon: Info, text: body || "", hasIcon: false };
}
